import { render, staticRenderFns } from "./ItemMarkdown.vue?vue&type=template&id=0559421a&lang=pug&"
import script from "./ItemMarkdown.vue?vue&type=script&lang=js&"
export * from "./ItemMarkdown.vue?vue&type=script&lang=js&"
import style0 from "./ItemMarkdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports